<template>
    <div class="content_box mobile_content">
        <div class="content role">
            <div class="title_box">
                <span class="title">APP群组管理</span>
            </div>
            <div class="search_box">
                <el-form :inline="true" class="demo-form-inline search-form form-list" label-width="100px">
                    <el-form-item>
                        <el-input placeholder="群组名称" clearable v-model="searchData.name"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.state" clearable placeholder="状态">
                            <el-option label="禁用" :value="0"></el-option>
                            <el-option label="启用" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="button button2 add" @click="addGroup" v-if="roleCheck('103-102-105-102')">
                <i class="el-icon-plus"></i>
                <span>新增群组</span>
            </div>
            <el-table :data="listData" style="width: 100%">
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="group_name" label="名称" min-width="300" show-overflow-tooltip></el-table-column>
                <el-table-column label="状态" prop="state">
                    <template slot-scope="scope">
                        <span class="status1" v-if="scope.row.state == 1">启用</span>
                        <span class="status0" v-if="scope.row.state == 0">禁用</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div>
                            <div class="button text" @click="groupShow(scope.row, 'update')"
                                v-if="roleCheck('103-102-105-102')">编辑</div>
                            <span v-else>--</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
            <Gh-Dialog ref="dislog" size="big" :title="dislog.title" @dialogBack="updateConfirm">
                <template v-slot:content>
                    <el-form label-width="100px" :model="actData">
                        <el-form-item label="群组名称"  class="is-required">
                            <el-input v-model="actData.group_name" maxlength="100" placeholder="请输入群组名称"></el-input>
                        </el-form-item>
                        <el-form-item label="高级筛选">
                            <el-switch v-model="actData.open_sel" active-color="#507FF7" inactive-color="#F7F8FA" @change="selChange">
                            </el-switch>
                        </el-form-item>
                        <div v-show="actData.open_sel == 1">
                            <el-form-item label="语言">
                                <el-select v-model="actData.language" multiple clearable placeholder="请选择">
                                    <el-option label="中文" value="zh"></el-option>
                                    <el-option label="英文" value="en"></el-option>
                                    <el-option label="德语" value="de"></el-option>
                                    <el-option label="法语" value="fr"></el-option>
                                    <el-option label="日语" value="ja"></el-option>
                                    <el-option label="俄语" value="ru"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="国家/地区">
                                <el-select v-model="actData.country" multiple clearable  filterable placeholder="请选择">
                                    <el-option v-for="item in countryList" :key="item.abbr"
                                        :label="item.chinese" :value="item.abbr"   ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="手机平台">
                                <el-select v-model="actData.phone_os" clearable placeholder="请选择">
                                    <el-option label="安卓" value="android"></el-option>
                                    <el-option label="iOS" value="ios"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="APP版本">
                                <div class="app_box">
                                    <el-select v-model="actData.app_add" clearable placeholder="请选择作用范围">
                                        <el-option label="大于" value=">"></el-option>
                                        <el-option label="大于等于" value=">="></el-option>
                                        <el-option label="等于" value="="></el-option>
                                        <el-option label="小于" value="<"></el-option>
                                        <el-option label="小于等于" value="<="></el-option>
                                    </el-select>
                                    <el-input class="margin_left" v-model="actData.app_version" placeholder="请输入APP版本"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item label="产品">
                                <div class="product_box el_form">
                                    <div class="product_item" v-for="(item, i) in actData.product_list">
                                        <div class="product_select">
                                            <el-select v-model="item.product" clearable placeholder="请选择"
                                                @change="productChange(i, item.product)" filterable>
                                                <el-option v-for="(item, i) in product_list" :key="i + '142'"
                                                    :label="item.name" :value="item.productKey"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="sw">
                                            <span class="label">固件版本</span>
                                            <el-select v-model="item.version" multiple clearable placeholder="请选择"
                                                collapse-tags filterable>
                                                <el-option v-for="item in version_list[i]" :key="item + '142'"
                                                    :label="item" :value="item"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="act_box">
                                            <img src="../../../assets/images/add.png" alt="添加产品" @click="addProduct"
                                                v-show="item.product">
                                            <img src="../../../assets/images/delete.png" alt="删除产品"
                                                @click="delProduct(i)" v-show="i != 0">
                                        </div>
                                    </div>
                                </div>
                            </el-form-item>
                        </div>
                        <el-form-item label="名单类型" v-show="!actData.open_sel"  class="is-required">
                            <el-radio v-model="name_type" :label="1"  @change="nameTypeChange">白名单</el-radio>
                            <el-radio v-model="name_type" :label="2"  @change="nameTypeChange">黑名单</el-radio>
                        </el-form-item>
                        <el-form-item label="白名单" v-show="name_type == 1 || actData.open_sel">
                            <el-input type="textarea" rows="5" v-model="actData.white_list"></el-input>
                        </el-form-item>
                        <el-form-item label="黑名单" v-show="name_type == 2 || actData.open_sel">
                            <el-input type="textarea" rows="5" v-model="actData.black_list"></el-input>
                        </el-form-item>
                        <el-form-item label="状态"  class="is-required">
                            <el-radio v-model="actData.state" :label="1">启用</el-radio>
                            <el-radio v-model="actData.state" :label="0">禁用</el-radio>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>
<script>
export default ({
    name: 'group-manage',
    data() {
        return {
            searchData: {
                page_size: 10,
                page: 1,
                group_name: '',
                state: ''
            },
            listData: [],
            total: 0,
            dislog: {
                type: '',
                title: ''
            },
            actData: {
            },
            product: [],
            product_list: [],
            version_list: [],
            countryList: [],
            name_type:1
        }
    },
    created() {
        this.getGroupList();
        this.getProductVersion();
        this.getIotProductList();
        this.getCountryList();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getGroupList();
        },
        addGroup() {
            this.dislog = {
                type: 'add',
                title: '新增群组'
            };
            this.version_list=[];
            this.actData = {
                group_name: '',
                open_sel: false,
                language: [],
                country: [],
                phone_os: '',
                app_add: '',
                app_version: '',
                product_list: [
                    { 'product': '', 'version': [] }
                ],
                white_list: '',
                black_list: '',
                state: 1,
            };
            this.name_type = 1;
            this.$refs.dislog.show = true;
        },
        getGroupList() {
            this.api.getGroupList(this.searchData).then(data => {
                this.listData = data.data.result;
                this.total = data.data.total;
            })
        },
        groupShow(row, type) {
            this.version_list=[];
            this.actData = {
                id: row.id,
                group_name: row.group_name,
                open_sel: row.open_sel || false,
                language: row.language || [],
                country: row.country || [],
                phone_os: row.phone_os,
                app_add: row.app_add,
                app_version: row.app_version,
                product_list: row.product_list.length >0 ? row.product_list : [{ 'product': '', 'version': [] }],
                white_list: row.white_list,
                black_list: row.black_list,
                state: row.state,
            };
            this.name_type = 1
            if(!row.white_list && row.black_list){
                this.name_type = 2
            }
            const that=this;
            this.actData.product_list.forEach(function (item, index, arr) {
                that.version_list[index] = that.product[item.product];
            });
            this.dislog = {
                type: type,
                title: '编辑群组'
            };
            this.$refs.dislog.show = true;
        },
        updateConfirm() {
            if (!this.actData.group_name) {
                this.$message.warning('请输入群组名称！');
                return;
            }
            if (this.actData.app_add && !this.actData.app_version) {
                this.$message.warning('请输入APP版本！');
                return;
            }
            if (!this.actData.app_add && this.actData.app_version) {
                this.$message.warning('请选择APP版本的作用范围！');
                return;
            }
            if(!this.actData.open_sel && !this.actData.white_list && !this.actData.black_list){
                this.$message.warning('请输入白名单或黑名单！');
                return;
            }
            if (this.actData.id) {
                this.actData.id = parseInt(this.actData.id)
            }
            // console.log(this.actData);
            this.api.updateGroup(this.actData).then(data => {
                this.$message.success('操作成功！');
                this.getGroupList();
                this.$refs.dislog.show = false;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getGroupList();
        },
        getProductVersion() {
            this.api.getProductVersion({}).then(data => {
                this.product = data.data.result;
            })
        },
        getIotProductList() {
            this.api.getIotProductList().then(data => {
                this.product_list = data.data.result;

            })
        },
        getCountryList() {
            this.api.getCountryList({}).then(data => {
                this.countryList = data.data;
            })
        },
        productChange(i, key) {
            this.version_list[i] = this.product[key];
            this.actData.product_list[i].version = [];
        },
        addProduct() {
            console.log(this.actData.product_list);
            this.actData.product_list.push({ 'product': '', 'version': [] });
        },
        delProduct(i) {
            this.actData.product_list.splice(i, 1)
        },
        nameTypeChange(){
            if(this.name_type==2 && !this.actData.open_sel){
                this.actData.white_list='';
            }
            if(this.name_type==1 && !this.actData.open_sel){
                this.actData.black_list='';
            }
        },
        selChange(){
            if(!this.actData.open_sel){
                this.actData.language=[],
                this.actData.country=[],
                this.actData.product_list=[{ 'product': '', 'version': [] }],
                this.actData.app_add='',
                this.actData.app_version='',
                this.actData.white_list='',
                this.actData.black_list='',
                this.actData.phone_os=''
            }
        }
    }
})
</script>
<style lang="less" scoped>
.margin_left {
    margin-left: 10px;
}

.margin_top {
    margin-top: 10px;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: end;
}

.app_box {
    display: flex;

}

.product_box {
    .flex {
        .flexLayout();
        flex-wrap: nowrap;
        justify-content: flex-start;
    }

    /deep/ .product_item {
        .flex();
        margin-bottom: 10px;

        .product_select,
        .sw {
            .flex();

            .label {
                min-width: 40px;
            }

            .el-input__inner {
                width: 200px;
                min-width: 200px;
            }
        }

        .product_select {
            margin-right: 20px;
        }

        .sw {
            .label {
                min-width: 60px;
                margin-right: 12px;
            }
        }

        .act_box {
            .flex();
            margin-left: 10px;

            img {
                width: 16px;
                margin-left: 10px;
                cursor: pointer;
            }
        }
    }
}

.status1 {
    color: #00D6B9;
}

.status0 {
    color: #EB534B;
}
</style>



// WEBPACK FOOTER //
// src/view/app/market-manage/group-manage.vue